module.exports = __webpack_public_path__ + "static/media/agronomySheets.38721522.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SuperUser/img/agronomySheets.png
// module id = 986
// module chunks = 0